import axios from "axios";
import type { AxiosInstance } from "axios";
import { appConfig } from "@/types/appConfig.type";

const API_URL: string | undefined = appConfig.VITE_API_BASE_URL;

if (!API_URL) {
  throw new Error("Missing VITE_API_BASE_URL");
}

const instance: AxiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    "Accept-Language": localStorage.getItem("language") || "fr",
  },
});

export default instance;
